import { truncateString } from '@/utils/strings'
import { Container, Content, ContainerAlignment, TruncatedContent, ContentSize } from './Tooltip.styles'
import { useRef, useState, ReactNode } from 'react'

export type TooltipProps = ContainerAlignment &
  ContentSize & {
    value: string | ReactNode
    length?: number
    children?: ReactNode
  }

export function Tooltip({ value, length, $size: size, $align: align = 'center', children }: TooltipProps): JSX.Element {
  const containerRef = useRef<HTMLDivElement>(null)
  const [tooltipPosition, setTooltipPosition] = useState({ top: 0, left: 0 })

  const handleMouseEnter = () => {
    if (containerRef.current) {
      const rect = containerRef.current.getBoundingClientRect()
      setTooltipPosition({
        top: rect.bottom + window.scrollY + 8,
        left: rect.left + rect.width / 2 + window.scrollX,
      })
    }
  }

  const isStringValue = typeof value === 'string'
  const truncatedString = isStringValue ? truncateString(value as string, length) : null
  const shouldShowTooltip =
    children || (isStringValue && truncatedString && truncatedString.length !== (value as string).length)

  return (
    <Container ref={containerRef} $align={align} onMouseEnter={handleMouseEnter} style={{ position: 'relative' }}>
      {children ? children : <TruncatedContent>{truncatedString}</TruncatedContent>}
      {shouldShowTooltip && (
        <Content
          $size={size}
          style={{
            top: tooltipPosition.top,
            left: tooltipPosition.left,
          }}>
          {value}
        </Content>
      )}
    </Container>
  )
}
